import BaseApi from './BaseApi';

export interface IPhoneNumberType {
    getAll(jwt: string): Promise<object>;
}

export default class PhoneNumberType extends BaseApi implements IPhoneNumberType {
    constructor(baseUrl: string) {
        super(baseUrl);

        this.getAll = this.getAll.bind(this);
    }

    public getAll(jwt: string) {
        return this.getRequest(`${this.baseUrl}v1.0/phoneNumberTypes`, jwt);
    }
}



// WEBPACK FOOTER //
// ./src/api/PhoneNumberType.ts